import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

const NotFound = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f8f8f8"
    >
      <Typography sx={{ fontSize: "24px !important",color:"red" }} >
        <Trans i18nKey="generic:404_error" />
      </Typography>
      <Typography variant="body1" mb={4}>
        {/* 你訪問的頁面不存在或已被移除。 */}
      </Typography>
      <Button className="loading-button" onClick={() => navigate("/")}>
        <Trans i18nKey="generic:back_to_home" />
      </Button>
    </Box>
  );
};

export default NotFound;
